import { connect } from 'react-redux';

import { trackSizeChange } from '../../actions/products';
import { isPreorderable } from '../../utils/selectors';

import ProductDetailSize from './ProductDetailSize';

export function mapStateToProps(state, ownProps) {
  return {
    isPreorderable: isPreorderable(state, ownProps),
    reviews: state.reviews,
  };
}

export default connect(mapStateToProps, { trackSizeChange })(ProductDetailSize);
